export default __webpack_public_path__ + "static/media/faverity.2ed06bca.svg";